
import React, { useState, useEffect } from "react";
import "./EventServices.css";
import { Link } from "react-router-dom";

/* ================= HERO SLIDER ================= */
const HERO_SLIDES = [
  {
    image: "/images/pp1.jpg",
    tag: "Weddings & Receptions",
  },
  {
    image: "/images/pp3.jpg",
    tag: "Birthdays & Parties",
  },
  {
    image: "/images/pp2.jpg",
    tag: "Corporate Events",
  },
];

/* ================= VR GAMING TEXT ================= */
const VRGaming = () => (
  <strong style={{ fontWeight: 800, color: "#000" }}>
    VR Gaming
  </strong>
);

/* ================= 3D EVENT ICONS ================= */
const EventIcon = ({ type }) => {
  const common = {
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "100%",
      overflow: "visible",
      filter: "drop-shadow(0 5px 4px rgba(0,0,0,0.13))",
    },
    "aria-hidden": true,
  };

  switch (type) {
    case "wedding":
      return (
        <svg {...common}>
          <defs>
            <linearGradient id="weddingDress" x1="18" y1="10" x2="45" y2="56">
              <stop stopColor="#FFF9ED" />
              <stop offset="1" stopColor="#D9C5A5" />
            </linearGradient>
          </defs>
          <path
            d="M25 12L32 8L39 12L36 23L47 48L32 56L17 48L28 23Z"
            fill="url(#weddingDress)"
            stroke="#A98B62"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M25 12L32 17L39 12L36 23L28 23Z"
            fill="#FFFFFF"
            stroke="#D0B78F"
            strokeWidth="1.2"
          />
          <path
            d="M28 23L32 31L36 23"
            stroke="#C7AA7B"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
          <path
            d="M17 48L32 44L47 48L32 56Z"
            fill="#E6D3B3"
            stroke="#A98B62"
            strokeWidth="1.3"
          />
          <path
            d="M25 12C20 7 18 14 23 17"
            stroke="#B89A70"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle cx="32" cy="7" r="3" fill="#D5B77E" />
        </svg>
      );

    case "reception":
      return (
        <svg {...common}>
          <defs>
            <linearGradient id="receptionFlower" x1="16" y1="10" x2="46" y2="49">
              <stop stopColor="#F9DCE8" />
              <stop offset="1" stopColor="#D58CAB" />
            </linearGradient>
          </defs>
          <path
            d="M32 30L22 53M32 30L42 53M32 30L32 55"
            stroke="#62866A"
            strokeWidth="2.5"
            strokeLinecap="round"
          />
          <path
            d="M30 42C19 32 14 42 29 46M34 45C44 34 51 43 35 49"
            fill="#A9C8A2"
            stroke="#62866A"
            strokeWidth="1.3"
          />
          <g fill="url(#receptionFlower)" stroke="#B66C8C" strokeWidth="1">
            <ellipse cx="32" cy="17" rx="7" ry="11" />
            <ellipse cx="32" cy="17" rx="7" ry="11" transform="rotate(72 32 17)" />
            <ellipse cx="32" cy="17" rx="7" ry="11" transform="rotate(144 32 17)" />
            <ellipse cx="32" cy="17" rx="7" ry="11" transform="rotate(216 32 17)" />
            <ellipse cx="32" cy="17" rx="7" ry="11" transform="rotate(288 32 17)" />
          </g>
          <circle cx="32" cy="17" r="5" fill="#E8C477" stroke="#BD9450" strokeWidth="1.2" />
          <path d="M13 9L15 13L19 15L15 17L13 21L11 17L7 15L11 13Z" fill="#D6B66F" />
        </svg>
      );

    case "birthday":
      return (
        <svg {...common}>
          <defs>
            <linearGradient id="cakeTop" x1="17" y1="22" x2="47" y2="38">
              <stop stopColor="#FFE6C6" />
              <stop offset="1" stopColor="#E8B98C" />
            </linearGradient>
          </defs>
          <path
            d="M15 31L32 23L49 31L32 40Z"
            fill="#FFF0D8"
            stroke="#C49B6C"
            strokeWidth="1.4"
            strokeLinejoin="round"
          />
          <path
            d="M15 31L32 40V55L15 46Z"
            fill="#E9B8A2"
            stroke="#BD8B79"
            strokeWidth="1.4"
          />
          <path
            d="M32 40L49 31V46L32 55Z"
            fill="#D99488"
            stroke="#B87B70"
            strokeWidth="1.4"
          />
          <path
            d="M15 31L32 23L49 31L32 40Z"
            fill="url(#cakeTop)"
            stroke="#C49B6C"
            strokeWidth="1.4"
          />
          <path d="M32 23V13" stroke="#A97A3F" strokeWidth="2" />
          <path
            d="M32 7C26 13 31 15 32 13C37 12 36 9 32 7Z"
            fill="#F0BB54"
          />
          <path d="M23 29L32 34L41 29" stroke="#FFFFFF" strokeWidth="2" />
          <path d="M32 40V55" stroke="#BD8B79" strokeWidth="1.2" />
          <circle cx="22" cy="15" r="2" fill="#D6B66F" />
          <circle cx="43" cy="17" r="2.5" fill="#D6B66F" />
        </svg>
      );

    case "engagement":
      return (
        <svg {...common}>
          <defs>
            <linearGradient id="ringGold" x1="17" y1="23" x2="45" y2="49">
              <stop stopColor="#FBE7A4" />
              <stop offset="1" stopColor="#BA8C35" />
            </linearGradient>
          </defs>
          <ellipse
            cx="32"
            cy="39"
            rx="17"
            ry="11"
            transform="rotate(-28 32 39)"
            stroke="url(#ringGold)"
            strokeWidth="6"
          />
          <ellipse
            cx="32"
            cy="39"
            rx="17"
            ry="11"
            transform="rotate(-28 32 39)"
            stroke="#FFF0B8"
            strokeWidth="1.2"
          />
          <path
            d="M32 8L41 17L32 29L23 17Z"
            fill="#EAF5FF"
            stroke="#A8C5DF"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M23 17L32 20L41 17M32 20V29"
            stroke="#B5D1E8"
            strokeWidth="1.2"
          />
          <path
            d="M23 17L18 24M41 17L46 24"
            stroke="#C6A35D"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      );

    case "haldi":
      return (
        <svg {...common}>
          <defs>
            <linearGradient id="haldiYellow" x1="16" y1="13" x2="47" y2="45">
              <stop stopColor="#FFF0A5" />
              <stop offset="1" stopColor="#E4A928" />
            </linearGradient>
          </defs>
          <g fill="url(#haldiYellow)" stroke="#C28D1D" strokeWidth="1">
            <ellipse cx="32" cy="21" rx="7" ry="15" />
            <ellipse cx="32" cy="21" rx="7" ry="15" transform="rotate(45 32 21)" />
            <ellipse cx="32" cy="21" rx="7" ry="15" transform="rotate(90 32 21)" />
            <ellipse cx="32" cy="21" rx="7" ry="15" transform="rotate(135 32 21)" />
          </g>
          <circle cx="32" cy="21" r="7" fill="#F5C747" stroke="#C28D1D" strokeWidth="1.5" />
          <path d="M32 29V55" stroke="#64865A" strokeWidth="2.5" strokeLinecap="round" />
          <path
            d="M31 42C18 31 12 43 30 47M33 47C46 34 53 44 34 51"
            fill="#A7C89C"
            stroke="#64865A"
            strokeWidth="1.5"
          />
          <circle cx="12" cy="14" r="2" fill="#E3B94F" />
          <circle cx="51" cy="12" r="2.5" fill="#E3B94F" />
        </svg>
      );

    case "baby":
      return (
        <svg {...common}>
          <defs>
            <linearGradient id="babyBlock" x1="16" y1="17" x2="47" y2="50">
              <stop stopColor="#E5F0FF" />
              <stop offset="1" stopColor="#A8C5E9" />
            </linearGradient>
          </defs>
          <path
            d="M15 25L32 16L49 25L32 34Z"
            fill="#F8FBFF"
            stroke="#A5BBD7"
            strokeWidth="1.5"
          />
          <path
            d="M15 25L32 34V52L15 43Z"
            fill="url(#babyBlock)"
            stroke="#8BA9CF"
            strokeWidth="1.5"
          />
          <path
            d="M32 34L49 25V43L32 52Z"
            fill="#C1D7F1"
            stroke="#8BA9CF"
            strokeWidth="1.5"
          />
          <path
            d="M32 4L34.8 10L41 11L36.5 15.5L37.5 22L32 19L26.5 22L27.5 15.5L23 11L29.2 10Z"
            fill="#E9C16B"
            stroke="#BD9850"
            strokeWidth="1.2"
            strokeLinejoin="round"
          />
          <circle cx="32" cy="39" r="4" fill="#FFFFFF" stroke="#8BA9CF" strokeWidth="1.2" />
          <path d="M21 34L26 37" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" />
        </svg>
      );

    case "puberty":
      return (
        <svg {...common}>
          <defs>
            <linearGradient id="celebrationFlower" x1="16" y1="11" x2="46" y2="45">
              <stop stopColor="#F4E4FA" />
              <stop offset="1" stopColor="#C2A0DA" />
            </linearGradient>
          </defs>
          <path d="M32 31L20 54M32 31L44 54M32 31V56" stroke="#668E69" strokeWidth="2.5" strokeLinecap="round" />
          <path
            d="M30 42C17 32 12 43 29 47M34 46C47 34 52 44 35 50"
            fill="#A6C7A3"
            stroke="#668E69"
            strokeWidth="1.4"
          />
          <g fill="url(#celebrationFlower)" stroke="#9F7DB9" strokeWidth="1">
            <ellipse cx="32" cy="19" rx="7" ry="13" />
            <ellipse cx="32" cy="19" rx="7" ry="13" transform="rotate(60 32 19)" />
            <ellipse cx="32" cy="19" rx="7" ry="13" transform="rotate(120 32 19)" />
          </g>
          <circle cx="32" cy="19" r="5" fill="#E8C879" stroke="#B99951" strokeWidth="1.2" />
          <path d="M12 9L14 13L18 15L14 17L12 21L10 17L6 15L10 13Z" fill="#D5B36D" />
          <path d="M51 27L53 30L56 32L53 34L51 37L49 34L46 32L49 30Z" fill="#D5B36D" />
        </svg>
      );

    case "corporate":
      return (
        <svg {...common}>
          <defs>
            <linearGradient id="officeFront" x1="14" y1="14" x2="35" y2="54">
              <stop stopColor="#F2F4F7" />
              <stop offset="1" stopColor="#AAB5C4" />
            </linearGradient>
          </defs>
          <path
            d="M13 24L33 13L33 54L13 54Z"
            fill="url(#officeFront)"
            stroke="#738196"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M33 13L50 22V54H33Z"
            fill="#D2DCE8"
            stroke="#738196"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path d="M19 29H25V35H19ZM19 40H25V46H19Z" fill="#FFFFFF" stroke="#92A4B9" strokeWidth="1" />
          <path d="M39 28H44V34H39ZM39 39H44V45H39Z" fill="#FFFFFF" stroke="#92A4B9" strokeWidth="1" />
          <path d="M29 54V45H36V54" fill="#7E8CA0" />
          <path d="M13 24L33 13L50 22L33 31Z" fill="#FFFFFF" stroke="#738196" strokeWidth="1.5" strokeLinejoin="round" />
          <path d="M33 31V13" stroke="#738196" strokeWidth="1.2" />
        </svg>
      );

    case "anniversary":
      return (
        <svg {...common}>
          <defs>
            <linearGradient id="anniversaryHeart" x1="15" y1="13" x2="48" y2="49">
              <stop stopColor="#F8D9DF" />
              <stop offset="1" stopColor="#D88D9D" />
            </linearGradient>
          </defs>
          <path
            d="M32 51L11 31C-1 17 15 5 25 15L32 22L39 15C49 5 65 17 53 31Z"
            fill="url(#anniversaryHeart)"
            stroke="#B76E80"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M32 51L32 22L39 15C49 5 65 17 53 31Z"
            fill="#C9798B"
            fillOpacity="0.35"
          />
          <path
            d="M17 19C19 15 23 16 25 19"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <path
            d="M32 29L35 35L42 36L37 41L38 47L32 44L26 47L27 41L22 36L29 35Z"
            fill="#F7E2A0"
            stroke="#B89449"
            strokeWidth="1"
            strokeLinejoin="round"
          />
        </svg>
      );

    default:
      return null;
  }
};

/* ================= SERVICES DATA ================= */
const SERVICES = [
  {
    id: 1,
    title: "Wedding",
    icon: "wedding",
    desc: (
      <>
        Enhance your wedding celebrations with next-level <VRGaming />{" "}
        entertainment from The HexaPlay. Our immersive gaming experiences
        provide a unique attraction for guests, creating unforgettable
        memories that last long after the celebration.
      </>
    ),
  },
  {
    id: 2,
    title: "Reception",
    icon: "reception",
    desc: (
      <>
        Make your wedding reception more interactive and memorable with{" "}
        <VRGaming /> entertainment. Guests can enjoy immersive virtual games
        that bring excitement, fun, and engagement to the celebration.
      </>
    ),
  },
  {
    id: 3,
    title: "Birthday",
    icon: "birthday",
    desc: (
      <>
        Make birthdays more exciting and unforgettable with our <VRGaming />{" "}
        experience. Guests of all age groups can enjoy thrilling and immersive
        virtual games that bring energy, fun, and interactive entertainment to
        birthday parties.
      </>
    ),
  },
  {
    id: 4,
    title: "Engagement",
    icon: "engagement",
    desc: (
      <>
        Bring a modern entertainment element to engagement celebrations with{" "}
        <VRGaming />. Guests can enjoy fun and immersive virtual reality
        experiences while celebrating the beginning of a beautiful journey
        together.
      </>
    ),
  },
  {
    id: 5,
    title: "Haldi",
    icon: "haldi",
    desc: (
      <>
        Make your Haldi ceremony more vibrant and fun with interactive{" "}
        <VRGaming />. Guests can enjoy exciting virtual experiences alongside
        traditional rituals, adding a perfect blend of culture and modern
        entertainment.
      </>
    ),
  },
  {
    id: 6,
    title: "Baby Shower",
    icon: "baby",
    desc: (
      <>
        Make baby shower celebrations more fun and interactive with The
        HexaPlay <VRGaming /> experience. Guests can enjoy safe and exciting
        virtual games that add joy and entertainment to the celebration.
      </>
    ),
  },
  {
    id: 7,
    title: "Puberty Function",
    icon: "puberty",
    desc: (
      <>
        Celebrate this important milestone with a unique entertainment
        experience. Our safe and exciting <VRGaming /> setup allows guests of
        all ages to enjoy interactive games and adds a modern attraction to
        the special celebration.
      </>
    ),
  },
  {
    id: 8,
    title: "Corporate Events",
    icon: "corporate",
    desc: (
      <>
        Boost team energy with interactive <VRGaming /> experiences at your
        corporate events. Perfect for team outings, employee engagement
        activities, product launches, and corporate celebrations.
      </>
    ),
  },
  {
    id: 9,
    title: "Anniversary",
    icon: "anniversary",
    desc: (
      <>
        Celebrate your special day with a unique and modern entertainment
        experience. Our <VRGaming /> setup adds fun, excitement, and interactive
        moments for couples, family, and guests, making your anniversary truly
        memorable.
      </>
    ),
  },
];

/* ================= ARROW ICONS ================= */
const ChevronLeft = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="15 18 9 12 15 6" />
  </svg>
);

const ChevronRight = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <polyline points="9 18 15 12 9 6" />
  </svg>
);

/* ================= COMPONENT ================= */
const EventServices = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const total = HERO_SLIDES.length;

  const prev = () =>
    setCurrentSlide((p) => (p === 0 ? total - 1 : p - 1));

  const next = () =>
    setCurrentSlide((p) => (p === total - 1 ? 0 : p + 1));

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((p) => (p === total - 1 ? 0 : p + 1));
    }, 4500);

    return () => clearInterval(timer);
  }, [total]);

  return (
    <div className="services-page">
    <style>{`
  .event-3d-icon {
    width: 76px;
    height: 76px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 22px;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 18px;
    background: linear-gradient(145deg, #ffffff, #f1f1f1);
    border: 1px solid rgba(0, 0, 0, 0.06);
    box-shadow:
      5px 5px 12px rgba(0, 0, 0, 0.07),
      -4px -4px 10px rgba(255, 255, 255, 0.95),
      inset 0 1px 1px rgba(255, 255, 255, 0.9);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }

  .event-service-card:hover .event-3d-icon {
    transform: translateY(-4px) scale(1.04);
    box-shadow:
      7px 9px 16px rgba(0, 0, 0, 0.10),
      -3px -3px 10px rgba(255, 255, 255, 0.95);
  }

  .event-service-card {
    min-width: 0;
    box-sizing: border-box;
  }

  .event-service-card p {
    overflow-wrap: anywhere;
  }

  @media (max-width: 768px) {
    .event-3d-icon {
      width: 66px;
      height: 66px;
      padding: 8px;
      margin-bottom: 18px;
      border-radius: 15px;
    }
  }

  @media (max-width: 480px) {
    .event-3d-icon {
      width: 60px;
      height: 60px;
      padding: 7px;
      margin-bottom: 16px;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .event-3d-icon,
    .event-service-card {
      transition: none !important;
    }
  }
`}</style>
     



      {/* ================= HERO SLIDER ================= */}
      <div className="hero-slider">
        {HERO_SLIDES.map((slide, index) => (
          <div
            key={index}
            className={`slide ${index === currentSlide ? "active" : ""}`}
          >
            <img
              src={slide.image}
              alt={slide.tag}
              className="slide-background-image"
            />

            <div className="slide-overlay" />

            <div className="slide-content">
              <span className="slide-tag">{slide.tag}</span>

              <h1>Our Event Services</h1>

              <p>
                Immersive <VRGaming /> Entertainment for Every Celebration
              </p>

              <Link to="/ServiceBookingForm" className="hero-book-btn">
                <span>Book Your Event</span>

                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </Link>
            </div>
          </div>
        ))}

        {/* Slider Arrows */}
        <button
          type="button"
          className="slider-arrow slider-arrow--prev"
          onClick={prev}
          aria-label="Previous slide"
        >
          <ChevronLeft />
        </button>

        <button
          type="button"
          className="slider-arrow slider-arrow--next"
          onClick={next}
          aria-label="Next slide"
        >
          <ChevronRight />
        </button>

        {/* Progress Bar */}
        <div className="slider-progress">
          <div
            className="slider-progress-bar"
            key={currentSlide}
          />
        </div>

        {/* Slider Dots */}
        <div className="slider-dots">
          {HERO_SLIDES.map((_, idx) => (
            <button
              key={idx}
              type="button"
              className={`dot ${idx === currentSlide ? "active" : ""}`}
              onClick={() => setCurrentSlide(idx)}
              aria-label={`Go to slide ${idx + 1}`}
            />
          ))}
        </div>
      </div>

      {/* ================= SERVICES GRID ================= */}
      <div className="services-container">
        <div className="section-header">
          <p className="section-eyebrow">What We Offer</p>
          <h2>Our Event Services</h2>
          <div className="divider" />
        </div>

        <div className="services-grid">
          {SERVICES.map((service) => (
            <div
              key={service.id}
              className="service-card event-service-card"
            >
              {/* Unique 3D-style event icon */}
              <div className="event-3d-icon">
                <EventIcon type={service.icon} />
              </div>

              <h3>{service.title}</h3>

              <p>{service.desc}</p>

              <Link to="/ServiceBookingForm" className="card-btn">
                <span>Book Now</span>

                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <line x1="5" y1="12" x2="19" y2="12" />
                  <polyline points="12 5 19 12 12 19" />
                </svg>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventServices;
